var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Search.CoauthorSearch = function (superClass) {
  extend(CoauthorSearch, superClass);
  function CoauthorSearch() {
    return CoauthorSearch.__super__.constructor.apply(this, arguments);
  }
  CoauthorSearch.prototype.initialize = function (options) {
    _.defaults(options, {
      includeContacts: true,
      placeholder: "Add co-authors...",
      formatNoMatches: this.trackNoResults,
      id: function (o) {
        return o.get('email') || o.get('encrypted_email');
      }
    });
    this.on('item-selected', this.addCoauthor, this);
    this.on('item-removed', this.removeCoauthor, this);
    return CoauthorSearch.__super__.initialize.apply(this, arguments);
  };
  CoauthorSearch.prototype.opening = function () {
    var footerContent;
    footerContent = JST["search/templates/coauthor_search_cant_find"]();
    return this.$el.select2("container").find("div.select2-drop").append(footerContent);
  };
  CoauthorSearch.prototype.trackNoResults = function () {
    return $a.admin_log("Coauthor search: no results");
  };
  CoauthorSearch.prototype._hideUsers = function () {
    return this.collection.pluck('tagged_user_id').concat(CoauthorSearch.__super__._hideUsers.apply(this, arguments));
  };
  CoauthorSearch.prototype.addCoauthor = function (searchUserModel) {
    return this.collection.add(Works.CoauthorTag.fromUserSearch(searchUserModel));
  };
  CoauthorSearch.prototype.removeCoauthor = function (coauthorTagModel) {
    return this.collection.remove(coauthorTagModel);
  };
  return CoauthorSearch;
}(window.Search.UserSearch);
window.extend = extend;
window.hasProp = hasProp;